<header
  class="sticky top-0 z-999 flex w-full flex-col border-gray-200 bg-white lg:border-b dark:border-gray-800 dark:bg-gray-900"
>
  @if (switchUserStatus?.switched_from) {
    <app-switch-user-banner [viewingAsName]="user?.name ?? ''"></app-switch-user-banner>
  }
  <div
    class="flex grow items-center justify-between px-3 py-3 lg:px-6 lg:py-4"
  >
    @if (showSidebarToggle) {
      <button
        [ngClass]="sidebarExpanded ? 'lg:bg-transparent dark:lg:bg-transparent bg-gray-100 dark:bg-gray-800' : ''"
        class="z-999 flex h-10 w-10 items-center justify-center rounded-lg border-gray-200 text-gray-500 lg:h-11 lg:w-11 lg:border dark:border-gray-800 dark:text-gray-400"
        (click)="toggleSidebar()"
      >

        @if (sidebarExpanded) {
          <lucide-icon class="hidden lg:block" [name]="PanelRightOpenIcon"></lucide-icon>
          <lucide-icon class="block lg:hidden" [name]="XIcon"></lucide-icon>
        } @else {
          <lucide-icon class="hidden lg:block" [name]="PanelRightCloseIcon"></lucide-icon>
          <lucide-icon class="block lg:hidden" [name]="MenuIcon"></lucide-icon>
        }

      </button>
    }

    @if (!showSidebarToggle) {
      <a routerLink="/my-home" class="flex items-center">
        <img
          priority
          [ngSrc]="logoUrl"
          alt="The Venue Group"
          height="40"
          width="160"
        />
      </a>
    }

    <div
      class="relative"
      [ngClass]="{ 'ml-auto': !showSidebarToggle }"
    >
        <button
          class="flex items-center text-gray-700 dark:text-gray-400"
          (click)="dropdownOpen = !dropdownOpen"
        >
          <span class="mr-3 overflow-hidden rounded-full">
            <lucide-icon [name]="User"></lucide-icon>
          </span>

          <span class="text-theme-sm mr-1 block font-medium">{{ user?.name }}</span>

          @if (dropdownOpen) {
            <lucide-icon [name]="ChevronUpIcon"></lucide-icon>
          } @else {
            <lucide-icon [name]="ChevronDownIcon"></lucide-icon>
          }

        </button>

        @if (dropdownOpen) {
          <div
            class="shadow-theme-lg dark:bg-gray-dark absolute right-0 mt-[17px] flex w-[240px] sm:w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 dark:border-gray-800"
          >
            <div>
            <span
              class="text-theme-sm block font-medium text-gray-700 dark:text-gray-400"
            >
              {{ user?.name }}
            </span>
              <span
                class="text-theme-xs mt-0.5 block text-gray-500 dark:text-gray-400"
              >
              {{ user?.email }}
            </span>
            </div>

            @if (switchUserStatus?.can_switch) {
              <button
                (click)="openSwitchUser()"
                class="group text-theme-sm mt-3 flex items-center gap-3 rounded-lg px-3 py-2 font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300"
              >
                <lucide-icon [name]="UserCogIcon"></lucide-icon>

                Switch user
              </button>
            }

            <button
              (click)="logout()"
              class="group text-theme-sm mt-3 flex items-center gap-3 rounded-lg px-3 py-2 font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300"
            >
              <lucide-icon [name]="LogOutIcon"></lucide-icon>

              {{ switchUserStatus?.switched_from ? 'Switch back' : 'Sign out' }}
            </button>
          </div>
        }
      </div>
  </div>
</header>

<app-switch-user-modal [show]="switchUserModalOpen" (onClose)="switchUserModalOpen = false"></app-switch-user-modal>
